module.exports = __webpack_public_path__ + "img/手表-3.8fe3b61c.png";